import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import { listInventoryItems } from "@/services/inventory/list-inventory-items";
import { queryKeys } from "./query-keys";

export const useInventoryItems = () => {
  const { state } = useAuth();

  return useQuery({
    queryKey: queryKeys.inventoryItems,
    queryFn: async () => {
      const response = await listInventoryItems();
      if (!response.ok) throw new Error(response.message);
      return response.data.player_items;
    },
    enabled: state.status === "authenticated",
  });
};

export const useInvalidateInventoryItems = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({ queryKey: queryKeys.inventoryItems });
};
